import React from 'react';
import PropTypes from 'prop-types';
import { BreakPointItem, BREAKPOINTS } from '@tfecom-thermofisher/react-komodo-design';

import { Button } from 'src/core/components';
import messages from '../../../messages';

const PoolButtons = ({
  onAdd,
  onRemove,
  disableAddButton,
  disableRemoveButton
}) => {
  const commonAddBtnProps = {
    type: 'outline',
    onClick: () => onAdd(),
    label: messages.addBtn,
    disabled: disableAddButton
  };
  const commonRemoveBtnProps = {
    type: 'outline',
    onClick: () => onRemove(),
    label: messages.removeBtn,
    disabled: disableRemoveButton,
    iconSize: 16
  };

  return (
    <div className="pooled-btn">
      <BreakPointItem min={BREAKPOINTS.lg}>
        <Button
          {...commonAddBtnProps}
          iconName="arrow-right-bold"
          iconSize={16}
        />
        <Button
          {...commonRemoveBtnProps}
          iconName="arrow-left-bold"
        />
      </BreakPointItem>
      <BreakPointItem max={BREAKPOINTS.lg} includeMax>
        <Button
          {...commonRemoveBtnProps}
          iconName="arrow-up-bold"
        />
        <Button
          {...commonAddBtnProps}
          iconName="arrow-down-bold"
          iconSize={24}
        />
      </BreakPointItem>
    </div>
  );
};

PoolButtons.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  disableAddButton: PropTypes.bool.isRequired,
  disableRemoveButton: PropTypes.bool.isRequired,
};

export default PoolButtons;
